import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  Typography,
  IconButton,
  CardContent,
  Chip,
  Card,
  Icon,
  Popover,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Avatar,
} from "@material-ui/core"
import PlaceIcon from "@material-ui/icons/Place"
import classNames from "classnames"
import { connect } from "react-redux"
import {
  createShoot,
  getShoots,
  deleteShoot,
  createCalendars,
  createMasterCalendar,
  updateShoot,
} from "../../actions/shoots"

import { openSnackBar } from "../../actions/snack-bar"
import { compose } from "recompose"

import Moment from "moment"
import crewmamaLogo from "../../assets/images/crewmama_brand.png"
import crewmamaCrown from "../../assets/images/crewmama_crown.svg"
import Image from "../../assets/images/login_bg.jpg"
import { withRouter } from "react-router-dom"

import { isEmpty } from "lodash"

const fixDate = date => {
  let dateToShow = null
  if (typeof date === "string") {
    dateToShow = new Date(
      date.slice(0, 19).replace("T", " ")
    ).toLocaleDateString()
  } else {
    dateToShow = date.toLocaleDateString()
  }

  return Moment(date).format("dddd, MMMM DD, YYYY")
}

class ShootCardComponent extends Component {
  state = {
    searchTerm: "",
    anchorEl: null,
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }

  chipText = t => (t ? t.toUpperCase() : "")

  duplicate = () => {
    const shoot = this.props.shoot
    this.setState({ anchorEl: null })
    const newShoot = {
      ...shoot,
      name: "Copy of " + shoot.name,
      start_date: shoot.start_date,
      end_date: shoot.end_date,
      call_time: shoot.call_time,
      full_day: shoot.day === "full" ? 1 : 0,
      location: JSON.stringify(shoot.location),
      firm: shoot.firm,
    }
    if (shoot.roles && shoot.roles.length > 0) {
      newShoot.glueData = {
        roles: shoot.roles.map(x => {
          return {
            role_id: x.role_id,
            client_rate: Number(x.client_rate),
            crew_rate: Number(x.crew_rate),
            user_id: x.user_id,
          }
        }),
      }
    }

    if (shoot.equipment.length > 0) {
      if (newShoot.glueData) {
        newShoot.glueData.equipment = shoot.equipment.map(x => {
          return {
            equipment_id: x.equipment_id,
          }
        })
      } else {
        newShoot.glueData = {
          equipment: shoot.equipment.map(x => {
            return {
              equipment_id: x.equipment_id,
            }
          }),
        }
      }
    }

    this.props
      .dispatch(createShoot(newShoot))
      .then(res => {
        let shootId = res.shoots[0].id
        return Promise.all([
          this.props.dispatch(createCalendars(shootId)),
          this.props.dispatch(createMasterCalendar(shootId)),
        ])
      })
      .then(res => {
        this.props.dispatch(getShoots())

        // window.location.href = "/shoots/" + res.shoots[0].id
      })
      .catch(console.log)
  }

  goToOwnShoot = e => {
    e.persist()
    if (
      // fix clicking on context menu
      e.target.id !== "more-vert-icon-" + this.props.shoot.id &&
      e.target.outerHTML !==
        '<div aria-hidden="true" style="z-index: -1; position: fixed; right: 0px; bottom: 0px; top: 0px; left: 0px; background-color: transparent; -webkit-tap-highlight-color: transparent; touch-action: none;"></div>' &&
      e.target.innerText !== "more_vert"
    ) {
      // window.location.href = "/my-shoots/" + this.props.shoot.id
      this.props.history.push("/my-shoots/" + this.props.shoot.id)
    }
  }

  goToShoot = e => {
    e.persist()
    if (
      // fix clicking on context menu
      e.target.id !== "more-vert-icon-" + this.props.shoot.id &&
      e.target.outerHTML !==
        '<div aria-hidden="true" style="z-index: -1; position: fixed; right: 0px; bottom: 0px; top: 0px; left: 0px; background-color: transparent; -webkit-tap-highlight-color: transparent; touch-action: none;"></div>' &&
      e.target.innerText !== "more_vert"
    ) {
      // window.location.href = "/my-shoots/" + this.props.shoot.id + "/details"

      this.props.history.push("/my-shoots/" + this.props.shoot.id + "/details")
    }
  }

  truncate = (text, size) => {
    return text.length > size ? text.slice(0, size - 1) + "…" : text
  }

  cancelShoot = () => {
    this.setState({ working: true })
    const { shoot } = this.props
    let newShoot = { ...shoot }
    newShoot.status = "cancelled"
    newShoot.location = JSON.stringify(newShoot.location)

    this.props
      .dispatch(updateShoot(newShoot.id, { ...newShoot }))
      .then(e => {
        this.props.dispatch(getShoots())
        // this.props.onUpdateShootStatus(e.id)
        this.props.dispatch(
          openSnackBar({ message: "Shoot Status is Updated" })
        )
        // this.setState({ working: false, changedStatus: event.target.value })
      })
      .catch(error => {
        this.props.dispatch(
          openSnackBar({
            message: "Something is wrong, shoot status is not update",
          })
        )
        this.setState({ working: false })
      })
  }

  render() {
    const {
      classes,
      shoot,
      authenticatedUser,
      activeCompany,
      accessLevel,
      setState,
      users,
      companyList,
    } = this.props

    let clientCompany =
      shoot && shoot.client_company
        ? companyList.find(cl => cl.id === shoot.client_company)
        : null

    let openPositions = []

    openPositions =
      !isEmpty(shoot.roles) &&
      shoot.roles.filter(role => {
        return !role.user_id
      })

    const { anchorEl } = this.state
    const canDelete =
      shoot.roles.length === 0 &&
      (shoot.creator_id === authenticatedUser.id ||
        (activeCompany !== null && activeCompany === shoot.company_id))
    let { location } = shoot
    if (typeof location === "string") {
      try {
        location = JSON.parse(shoot.location)
      } catch (err) {
        location = null
      }
    }
    let creator = null
    if (users.length > 1) {
      creator = users.find(x => Number(x.id) === Number(shoot.creator_id))
    }

    return (
      <Fragment>
        <Card
          className={classes.card}
          onClick={
            creator && authenticatedUser && creator.id === authenticatedUser.id
              ? this.goToOwnShoot
              : this.goToShoot
          }
        >
          {/* <CardMedia className={classes.media} image={Image}/> */}
          {/* <StaticGoogleMap
            style={
              "feature:administrative%7Celement:labels.text.fill%7Ccolor:0x6195a0&style=feature:landscape%7Ccolor:0xf2f2f2&style=feature:landscape%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:poi%7Cvisibility:off&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0xe6f3d6%7Cvisibility:on&style=feature:road%7Csaturation:-100%7Clightness:45%7Cvisibility:simplified&style=feature:road.arterial%7Celement:geometry.fill%7Ccolor:0xf4f4f4&style=feature:road.arterial%7Celement:labels.icon%7Cvisibility:off&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x787878&style=feature:road.highway%7Cvisibility:simplified&style=feature:road.highway%7Celement:geometry.fill%7Ccolor:0xf4d2c5%7Cvisibility:simplified&style=feature:road.highway%7Celement:labels.text%7Ccolor:0x4e4e4e&style=feature:transit%7Cvisibility:off&style=feature:water%7Ccolor:0xeaf6f8%7Cvisibility:on&style=feature:water%7Celement:geometry.fill%7Ccolor:0xeaf6f8"
            }
            size="300x150"
            center={`${location.lat},${location.lon}`}
            zoom="13"
            apiKey="AIzaSyBAXVn9aO5CS7jsiNYgwwrQIns6cJ7RvlY"
          >
            <Marker location={`${location.lat},${location.lon}`} />
          </StaticGoogleMap> */}
          <div className={classes.imgWrapper}>
            {clientCompany ? (
              clientCompany.logo_image && (
                <img
                  className={classes.formLogo}
                  src={
                    clientCompany.logo_image !== null
                      ? `https://res.cloudinary.com/${
                          process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                        }/image/upload/v${
                          JSON.parse(clientCompany.logo_image).version
                        }/${JSON.parse(
                          clientCompany.logo_image
                        ).public_id.replace(/\s/g, "")}.${JSON.parse(
                          clientCompany.logo_image
                        ).format.replace(/\s/g, "")}`
                      : ""
                  }
                  alt={`${clientCompany.name}`}
                />
              )
            ) : (
              <img
                src={crewmamaLogo}
                alt="Crew Mama"
                className={classes.formLogo}
              />
            )}
          </div>

          <div className={classes.chipWrapper}>
            <Chip
              label={this.chipText(shoot.status)}
              className={classNames(classes.chip, {
                [classes.chipBlue]:
                  shoot.status && shoot.status.toLowerCase() === "booked",
                [classes.chipGreen]:
                  shoot.status && shoot.status.toLowerCase() === "wrapped",
                [classes.chipRed]:
                  shoot.status && shoot.status.toLowerCase() === "open",
                [classes.chipGrey]:
                  shoot.status && shoot.status.toLowerCase() === "cancelled",
                [classes.chipPurple]:
                  shoot.status && shoot.status.toLowerCase() === "billed",
              })}
            />
            <br />
            {shoot.status &&
              (shoot.status.toLowerCase() === "booked" ||
                shoot.status.toLowerCase() === "open") && (
                <Chip
                  label={this.chipText(shoot.firm ? "Firm" : "Standby")}
                  style={{ marginTop: "8px" }}
                  className={classNames(classes.chip, {
                    [classes.chipYellow]: !shoot.firm,
                    [classes.chipGreen]: shoot.firm,
                  })}
                />
              )}
          </div>
          <CardContent>
            <div style={{ display: "flex", paddingTop: "30px" }}>
              <Tooltip title={shoot.name} placement="top">
                <Typography className={classes.title} gutterBottom variant="h6">
                  {fixDate(shoot.start_date)}
                </Typography>
              </Tooltip>
              {/* <div>
                <Typography
                  className={classes.date}
                  gutterBottom
                  variant="subtitle1"
                >
                  {fixDate(shoot.start_date)}
                </Typography>
                {fixDate(shoot.start_date) !== fixDate(shoot.end_date) && (
                  <Typography
                    className={classes.date}
                    gutterBottom
                    variant="subtitle1"
                  >
                    {fixDate(shoot.end_date)}
                  </Typography>
                )}
              </div> */}
            </div>
            <div style={{ display: "flex" }}>
              {/* <Tooltip title={shoot.name} placement="top"> */}
              <Typography
                className={classes.shootName}
                gutterBottom
                variant="caption"
              >
                {shoot.name}
              </Typography>
              {/* </Tooltip> */}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <PlaceIcon className={classes.placeIcon} />
              <Typography
                variant="caption"
                className={classes.placeName}
                color="inherit"
              >
                {location ? location.city + ", " + location.state : "TBD"}
              </Typography>
              <div style={{ flexGrow: 1 }} />
              {/* {shoot.status !== "cancelled" && (
                <IconButton
                  onClick={e => {
                    this.setState({ anchorEl: e.currentTarget })
                  }}
                >
                  <Icon id={"more-vert-icon-" + shoot.id}>more_vert</Icon>
                </IconButton>
              )} */}
            </div>
          </CardContent>
          <CardContent>
            <div style={{ display: "flex" }}>
              {creator && (
                <div
                  style={{
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {!isEmpty(shoot.roles) ? (
                    <Typography
                      variant="caption"
                      style={{ color: "grey" }}
                      className={classes.placeName}
                    >
                      Crew:
                    </Typography>
                  ) : (
                    <Typography
                      variant="caption"
                      style={{ color: "grey" }}
                      className={classes.placeName}
                    >
                      No Positions Added
                    </Typography>
                  )}
                  <div style={{ flexGrow: 1 }} />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      paddingTop: "20px",
                    }}
                  >
                    {!isEmpty(shoot.users) &&
                      shoot.users.map((user, crewIndex) => {
                        if (user.user_id) {
                          let crew = shoot.roles.find(
                            c => c.user_id === user.user_id
                          )
                          return (
                            crew && (
                              <div>
                                <Avatar
                                  className={[
                                    classes.purple,
                                    classes.positionAbsolute,
                                    classes.large,
                                  ]}
                                  src={
                                    !isEmpty(user.profile_image)
                                      ? `https://res.cloudinary.com/adesk/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${
                                          JSON.parse(user.profile_image).version
                                        }/${
                                          JSON.parse(user.profile_image)
                                            .public_id
                                        }.${
                                          JSON.parse(user.profile_image).format
                                        }`
                                      : Image
                                  }
                                >
                                  OP
                                </Avatar>
                                <Tooltip title={crew.name} placement="top">
                                  <Typography
                                    variant="caption"
                                    style={{ color: "grey" }}
                                    className={classes.placeName}
                                  >
                                    {this.truncate(crew.name, 10)}
                                  </Typography>
                                </Tooltip>
                              </div>
                            )
                          )
                        }
                      })}

                    {!isEmpty(openPositions) &&
                      openPositions.map((position, crewIndex) => (
                        <div>
                          <Avatar
                            className={[
                              classes.purple,
                              classes.positionAbsolute,
                              classes.large,
                            ]}
                            src={Image}
                          >
                            OP
                          </Avatar>
                          <Tooltip title={position.name} placement="top">
                            <Typography
                              variant="caption"
                              style={{ color: "grey" }}
                              className={classes.positionName}
                            >
                              {this.truncate(position.name, 10)}
                            </Typography>
                          </Tooltip>
                        </div>
                      ))}
                  </div>
                </div>
              )}
              <div style={{ flexGrow: 1 }} />
              <Tooltip
                title={
                  shoot.roles.length > 0 ? (
                    <div>
                      {shoot.roles.map(x => {
                        return (
                          <div key={x.id + ":" + x.user_id}>
                            {x.name +
                              (x.user_id &&
                              this.props.users.length > 1 &&
                              this.props.users.findIndex(
                                y => y.id === x.user_id
                              ) !== -1
                                ? `: ${
                                    this.props.users.find(
                                      y => y.id === x.user_id
                                    ).full_name
                                  }`
                                : "")}
                          </div>
                        )
                      })}
                    </div>
                  ) : (
                    ""
                  )
                }
              >
                <div>
                  {!isEmpty(shoot.roles) &&
                    !isEmpty(openPositions) && (
                      <Typography
                        variant="caption"
                        className={classes.placeName}
                        style={{ color: "grey" }}
                      >
                        {openPositions.length +
                          " of " +
                          shoot.roles.length +
                          " Open Positions"}
                      </Typography>
                    )}
                </div>
              </Tooltip>
            </div>

            <div className={classes.representativeSection}>
              <div>
                <img
                  src={crewmamaCrown}
                  alt="Crew Mama"
                  className={classes.representativeLogo}
                />
                <Typography
                  variant="caption"
                  style={{ color: "grey" }}
                  className={classes.placeName}
                >
                  Crew Mama Rep:{" "}
                  {shoot.repsentative_name && shoot.repsentative_name}
                </Typography>
              </div>
              <Typography
                variant="caption"
                style={{ color: "grey" }}
                className={classes.placeName}
              >
                ID: {shoot.id}
              </Typography>
            </div>
            {creator && (
              <div className={classes.representativeSection}>
                <Typography
                  variant="caption"
                  style={{ color: "grey" }}
                  className={classes.placeName}
                >
                  Booked By: {creator.full_name}
                </Typography>
              </div>
            )}
          </CardContent>
        </Card>

        {/* <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={e => {
            this.setState({ anchorEl: null })
          }}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <List>
            <ListItem
              style={{ cursor: "pointer" }}
              onClick={e => this.duplicate()}
            >
              <ListItemText>Duplicate</ListItemText>
            </ListItem>
            <Tooltip
              placement="top"
              title={"this will cancel the shoot"}
            >
              <ListItem
                style={{ cursor: "pointer" }}
                onClick={
                  e =>
                    setState({
                      popover: {
                        func: e => (e ? this.cancelShoot() : ""),
                        anchor: e.currentTarget,
                      },
                    })
                }
              >
                <ListItemText>Cancel Shoot</ListItemText>
              </ListItem>
            </Tooltip>
          </List>
        </Popover> */}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    // history: state.history,
    authenticatedUser: state.authentication.authenticatedUser,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    users: state.misc.users,
    companyList: state.clients.companiesList,
  }
}

const connector = connect(mapStateToProps)

export default withRouter(
  compose(withStyles(styles))(connector(ShootCardComponent))
)
